export { Empty } from './Empty';

export type { EmptyProps } from './Empty';
